import { createRequestsReducer } from 'redux-thunk-data'

export default createRequestsReducer()
